import { render, staticRenderFns } from "./FeedsForm.vue?vue&type=template&id=1cc19b4c&scoped=true&"
import script from "./FeedsForm.vue?vue&type=script&lang=js&"
export * from "./FeedsForm.vue?vue&type=script&lang=js&"
import style0 from "./FeedsForm.vue?vue&type=style&index=0&id=1cc19b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc19b4c",
  null
  
)

export default component.exports